\:host
    display: block
    width: 100%
    height: 100%

.RCPContainer
    position: relative
    width: 100%
    height: 100%
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: stretch
    background: rgb($globalSettingsBackgroundPrimary)
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    border-top: 1px solid rgb($globalSettingsBackgroundSecondary)
    box-sizing: border-box
    @media #{$mobile}
        flex-direction: column
        overflow-y: auto
    .RCPActions
        width: calc(100% - 340px)
        height: 100%
        padding: 0 20px
        display: flex
        flex-direction: column
        flex-grow: 1
        flex-shrink: 0
        border-right: 1px solid rgb($globalSettingsStrokeTertiary)
        box-sizing: border-box
        overflow-y: auto
        @media #{$mobile}
            width: 100%
            height: unset
    .RCPSummary
        width: 320px
        height: 100%
        display: flex
        flex-direction: column
        justify-content: space-between
        flex-grow: 1
        flex-shrink: 0
        box-sizing: border-box
        overflow-y: auto
        @media #{$mobile}
            width: 100%
            height: unset
        .RCPAccordion
            display: flex
            justify-content: stretch
            align-items: stretch
            flex-grow: 1
            z-index: 1
            @media #{$mobile}
                min-height: 300px
        .ShippingWrapper
            padding: 0 20px
        .DateWrapper
            padding: 0 20px
            span
                font-weight: 700
        .RCPTerms
            width: 100%
            max-height: 60%
            padding: 20px
            display: flex
            flex-direction: column
            flex-shrink: 0
            box-sizing: border-box
            box-shadow: 0px -5px 15px 0px rgba($globalSettingsBackgroundShadowColor, 0.1)
            z-index: 2
            @media #{$mobile}
                max-height: unset
                padding-bottom: 70px
            .RCPTermsScrollable
                padding-right: 10px
                overflow-y: auto
                background: linear-gradient(rgb($globalSettingsBackgroundPrimary) 30%, rgba($globalSettingsBackgroundShadowColor, 0)) center top, linear-gradient(rgba($globalSettingsBackgroundShadowColor, 0), rgb($globalSettingsBackgroundPrimary) 70%) center bottom, radial-gradient(farthest-side at 50% 0, rgba($globalSettingsBackgroundShadowColor, 0.2), rgba($globalSettingsBackgroundShadowColor, 0)) center top, radial-gradient(farthest-side at 50% 100%, rgba($globalSettingsBackgroundShadowColor, 0.2), rgba($globalSettingsBackgroundShadowColor, 0)) center bottom
                background-repeat: no-repeat
                background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px
                background-attachment: local, local, scroll, scroll
                .RCPTermsItem
                    width: 100%
                    font-size: 12px
                    display: flex
                    flex-direction: column
                    flex-shrink: 0
            .RCPPriceRow
                width: 100%
                font-size: 14px
                display: flex
                flex-direction: row-reverse
                justify-content: space-between
                align-items: center
                gap: 4px
                flex-shrink: 0
                .RCPPriceFieldL
                    min-width: calc(50% - 2px)
                    display: flex
                    gap: 3px
                    overflow: hidden
                .RCPPriceFieldR
                    min-width: calc(50% - 2px)
                    display: flex
                    justify-content: flex-end
                    gap: 3px
                    overflow: hidden
                .RCPPriceValue
                    flex-shrink: 0
        .RCPTermsButton
            width: 100%
            flex-shrink: 0
            margin-top: 10px
            @media #{$mobile}
                position: fixed
                left: 0
                right: 0
                bottom: 0
                width: unset
                box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor, 0.5), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor, 0.5)
                *
                    border-radius: 0
    .RCPPaymentTitle
        width: 100%
        font-size: 16px
        font-weight: 700
        box-sizing: border-box
    .RPCTextAreaWrapper
        position: relative
        width: 100%
        margin-top: -9px
    .RCPTextAreaLabel
        position: relative
        z-index: 1
        display: inline-block
        transform: translateY(6px)
        line-height: 1
        padding: 1px 5px
        font-size: 12px
        font-weight: 700
        background: rgb($globalSettingsBackgroundPrimary)
        pointer-events: none
        color: rgb($globalSettingsFontTertiary)
        white-space: nowrap
        box-sizing: border-box
        user-select: none
    textarea
        height: 80px
        width: 100%
        position: relative
        resize: none
        font-size: 12px
        box-sizing: border-box
        padding: 6px
        margin: 0
        border: 1px solid rgb($globalSettingsStrokeSecondary)
        border-radius: 0 $globalButtonRounding $globalButtonRounding $globalButtonRounding
        box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
        background-color: rgb($globalSettingsBackgroundPrimary)
        color: rgb($globalSettingsFontPrimary)
        &:hover
            border: 1px solid rgb($globalSettingsStrokePrimary)
        &:focus
            outline: none
            border: 1px solid rgb($globalSettingsStrokePrimary)
